module.exports = {
    active: 'active',
    done: 'done',
    failed: 'failed',
};
